import { render, staticRenderFns } from "./AlphaPage.vue?vue&type=template&id=13e2053d&scoped=true&"
import script from "./AlphaPage.vue?vue&type=script&lang=js&"
export * from "./AlphaPage.vue?vue&type=script&lang=js&"
import style0 from "./AlphaPage.vue?vue&type=style&index=0&id=13e2053d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e2053d",
  null
  
)

export default component.exports